import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const MapSizeInvalidator = ({ isLoading, isFullscreen }: { isLoading?: boolean; isFullscreen?: boolean }) => {
	const map = useMap();

	useEffect(() => {
		if (!map) return;

		// delay to ensure map container has resized
		const t = setTimeout(() => {
			map.invalidateSize({ animate: false, pan: false });
		}, 50);

		return () => clearTimeout(t);
	}, [isLoading, isFullscreen, map]);

	return null;
};
